import React, {useState, useEffect, useContext} from "react";
import Cookies from "js-cookie";
import { Box, Button, Paper, Typography } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import InlineEditor from '@ckeditor/ckeditor5-build-inline';
import axios from "axios";
import { API } from "../../../controller/api";
import { useLocation, useNavigate } from "react-router-dom";
import { DrawerContext } from "../../../controller/context/DrawerWidthContext";
import { Spinner } from "react-bootstrap";
import { Circle } from "../components/Circle";
import DownloadDocxButton from "../components/DownloadDocx";







export const Editor = ()=>{
   const user = JSON.parse(Cookies.get('user'));
       const userId = user.id;
    
    const location = useLocation();
    const state = location.state;
    const navigate = useNavigate();
    const [data, setData] = useState(null)
    const [editorContent, setEditorContent] = useState(state.data.content);
    const [job, setJob] = useState(state.data.documentName)

    const { drawerWidth } = useContext(DrawerContext);
    const [loading, setLoading] = useState(false)
useEffect(()=>{
  console.log(location.state)
},[])
    const handleBack = ()=>{
        const check = window.confirm('If you choose to go back your questionnaire will not be saved. Are you sure you would like to do this?')
        if(check){
          navigate(-1)
        }
        }

        const handleEditorChange = (event, editor) => {
            const data = editor.getData();
            setEditorContent(data);
          };

    return (
        <div style={{ overflowY: "auto", maxHeight: "100vh", paddingBottom: 100, marginTop: 80 }}>


            <Box sx={{marginBottom:'10px',
         marginLeft: { xs: drawerWidth === 0 ? 38 : 0, sm: drawerWidth === 0 ? 38 : 0}

            }}>
            <Button variant="contained" onClick={handleBack}><ArrowBackIosNewIcon/> <b>BACK</b></Button>

            <DownloadDocxButton htmlContent={editorContent} docName={job} />

            <Button onClick={async ()=>{
                setLoading(true)
                 let object = {
                    id:state.data.id,
                    dateCreated: state.data.dateCreated,
                    documentName: job,
                    content: editorContent
                }
               console.log(object)
           const response = await  axios.post(`${API}/${state.route}/update`,{userId: userId, object:object})
           if(response.data === "Updated successfully"){
              window.alert('The changes have been saved.')
              setLoading(false)

           } else {
            setLoading(false)

            window.alert('Something went wrong. Please try again.')
           }
                
                }} sx={{marginLeft:'10px', float:'right', display:'inline'}}  variant="contained"><b>SAVE UPDATES</b><Spinner style={{marginLeft:5, display:loading? 'inline-block': 'none'}} size="sm"/></Button>
                
            </Box>
<Box sx={{ marginTop:2, marginBottom:2,
          marginLeft: { xs: drawerWidth === 0 ? 38 : 0, sm: drawerWidth === 0 ? 38 : 0}
}}>
                <Typography variant="button" sx={{fontSize:'16px'}}><b><Circle Title="!" Color="#0172C0"/>&nbsp; Edit Document:</b> Click to edit the document.</Typography>

</Box>
<Paper sx={{ p: 2, display: "flex", flexDirection: "column",           marginLeft: { xs: drawerWidth === 0 ? 38 : 0, sm: drawerWidth === 0 ? 38 : 0}
 }}>
         
    <div style={{ height:'100%'}}>
    <div style={{ height:'100%'}}>
    <CKEditor
        editor={InlineEditor}
     
        data={editorContent}
        onChange={handleEditorChange}
      />
    
              
    </div>

              
    </div>
   
    </Paper>
    </div>
)
}